import React from 'react';
import PropTypes from 'prop-types';

export default class LocationSelectInput extends React.Component {

    static propTypes = {
        name: PropTypes.string,
        onPlaceSelected: PropTypes.func,
        types: PropTypes.array,
        componentRestrictions: PropTypes.object,
        bounds: PropTypes.object,
    };


    //  Virtual Latitude
    vLat;

    //  Virtual Longitude
    vLng;

    constructor(props) {
        super(props);
        this.autocomplete = null;
    }

    componentDidMount() {

        try {

            const google = window.google;

            const {types = ['(cities)'], componentRestrictions, bounds,} = this.props;

            const config = {
                types,
                bounds,
            };

            if (componentRestrictions) {
                config.componentRestrictions = componentRestrictions;
            }

            this.autocomplete = new google.maps.places.Autocomplete(this.refs.input, config);

            this.autocomplete.addListener('place_changed', this.onSelected.bind(this));

        }
        catch(ex) {
            console.log('Failed initializing google places');
        }

    }

    onSelected() {

        this.vLng = null;
        this.vLat  = null;

        if (this.props.onPlaceSelected) {
            this.props.onPlaceSelected(this.autocomplete.getPlace());
        }

    }

    getPlaceFull(){
        let place = this.autocomplete ? this.autocomplete.getPlace() : null;
        let txt = this.getPlaceText();
        return {
            text: txt,
            lat: txt.length == 0 ? null : (this.vLat  != undefined ? this.vLat  : (place && place.geometry ?  place.geometry.location.lat() : undefined)),
            lng: txt.length == 0 ? null : (this.vLng != undefined ? this.vLng :  (place && place.geometry ?  place.geometry.location.lng() : undefined))
        };
    }

    getPlaceText(){
        return this.refs.input.value;
    }



    setLocation(value , lat, lng) {

        this.refs.input.value = value;

        if(lat&& lng){
            this.vLat = lat;
            this.vLng = lng;
        }
    }

    clearInput(){
        this.refs.input.value = null;
        this.vLng = undefined;
        this.vLat = undefined;
    }

    focus(){
        this.refs.input.focus();
    }

    render() {

        const {onPlaceSelected, types, componentRestrictions, bounds, ...rest} = this.props;

        return (
            <div style={{width: '100%'}}>
                <input
                    name={this.props.name}
                    className={this.props.className}
                    ref="input"
                    {...rest} />
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/LocationSelectInput/LocationSelectInput.js